// App.tsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import RedirectPage from "./RedirectPage";
import { ThemeProvider } from "@mui/material";
import { resolveTheme } from "./Utils/themeResolver";

function ThemedApp() {
  const location = useLocation();
  const theme = resolveTheme(location.search);

  return (
    <ThemeProvider theme={theme}>
      <div data-iframe-height>
        <Routes>
          <Route path="/redirect/:id" element={<RedirectPage />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

function App() {
  return (
    <Router>
      <ThemedApp />
    </Router>
  );
}

export default App;
